angular.module("vgresiduos").directive("disposalTemporaryStoragerStep", function () {
	return {
		scope: true,
		controller: "DisposalTemporaryStoragerStepCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalTemporaryStoragerStep/disposalTemporaryStoragerStep_template.html"
	};
});
